<template>
  <div id="team-container">
    <iframe
      frameborder="1"
      :height="`${height}px`"
      width="100%"
      scrolling="no"
      :src="`${VUE_APP_BASE_AUTH_MODULE}/team/talent`"
      allow="clipboard-read; clipboard-write"
    />

    <ModalPIN
      id="modal-verify-pin"
      :no-close-on-backdrop="false"
      :no-close-on-esc="false"
      title="Verifikasi PIN"
      description="Mohon verifikasi identitas kamu dengan masukan PIN"
      label-confirm-button="Konfirmasi"
      label-cancel-button="Kembali"
      @on-confirm-button="onSubmit"
      @on-cancel-button="$bvModal.hide('modal-verify-pin')"
    />

    <ModalMaxChancePIN />
    <ModalConfirm
      id="finish-onboarding"
      title="Data Berhasil Disimpan"
      description="Tim Komtim akan segera menghubungimu untuk proses selanjutnya. Jika ada kendala, hubungi kami melalui nomor berikut:"
      @hidden="$router.replace('/talent')"
    >
      <a
        href="http://wa.me/6283865360055"
        target="_blank"
        rel="noopener noreferrer"
        class="whitespace-nowrap mt-[20px] bg-[#34A853] hover:bg-[#2B8C45] transition-colors duration-300 text-white text-sm font-semibold flex items-center justify-center gap-[12px] h-[42px] rounded-md px-[16px]"
        @click="$bvModal.hide('finish-onboarding')"
      >
        <img
          src="https://storage.googleapis.com/komerce/assets/LP-Komcard/whatsapp.svg"
          class="brightness-0 invert"
          alt="wa"
          width="24"
          height="24"
          loading="lazy"
        >
        Hubungi Kami
      </a>
    </ModalConfirm>
  </div>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import secureLs from '@/libs/secureLs'
import ModalMaxChancePIN from '@/views/components/modal/ModalMaxChancePIN.vue'
import ModalConfirm from '../modal/ModalConfirm.vue'

export default {
  components: { ModalPIN, ModalMaxChancePIN, ModalConfirm },
  data() {
    return {
      height: 0,
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      key: null,
      userId: null,
      endpoint: '/auth/api/v1/teams',
      password: null,
      pin: null,
    }
  },
  mounted() {
    const { tab, from } = this.$route.query
    setTimeout(() => {
      const iframe = document.querySelector('#team-container iframe')
      iframe.contentWindow.postMessage({ tab: tab || 'internal' }, '*')
    }, 1000)
    if (from === 'onboarding') {
      this.$bvModal.show('finish-onboarding')
    }
    window.addEventListener('message', this.watchIframe)
  },
  destroyed() {
    window.removeEventListener('message', this.watchIframe)
  },
  methods: {
    watchIframe(event) {
      if (event.origin === this.VUE_APP_BASE_AUTH_MODULE) {
        const {
          type, data, route, key, userId, password, pin,
        } = event.data

        if (type === 'SET_DIMENSION') {
          this.height = Math.floor(data.height)
        }

        if (['DELETE', 'RESET_PASSWORD', 'RESET_PIN'].includes(key)) {
          this.key = key
          this.userId = userId
          this.$bvModal.show('modal-verify-pin')
          this.password = password
          this.pin = pin
        }

        if (key === 'MAX_PIN_ATTEMPT') {
          this.$bvModal.show('max-chance-PIN')
        }

        if (route) {
          if (route.startsWith('/talent?tab')) {
            this.$router.replace(route)
            return
          }
          this.$router.push(route)
        }
      }
    },
    onSubmit() {
      const { data: { usable_token } } = secureLs.getItem('verify')
      if (this.key === 'DELETE') {
        this.onDelete(usable_token)
      } else if (this.key === 'RESET_PASSWORD') {
        this.onResetPassword(usable_token)
      } else if (this.key === 'RESET_PIN') {
        this.onResetPin(usable_token)
      }
    },
    async onDelete(token) {
      await newAxiosIns.delete(`${this.endpoint}/${this.userId}?token=${token}`)
        .then(() => {
          this.$toast_success({ message: 'Berhasil menghapus team' })
          this.sendMessage('refetch')
        })
        .catch(() => {
          this.$toast_error({ message: 'Terjadi kesalahan saat menghapus team!' })
        })
    },
    async onResetPassword(token) {
      const url = `/auth/api/v1/teams/${this.userId}/reset-password`
      const payload = {
        password: this.password,
        token,
      }

      await newAxiosIns.put(url, payload)
        .then(() => {
          this.$toast_success({ message: 'Informasi reset password telah dikirim ke email kamu dan team' })
          this.sendMessage('reset_form')
        })
        .catch(() => {
          this.$toast_error({ message: 'Terjadi kesalahan saat mereset password!' })
        })
    },
    async onResetPin(token) {
      const url = `/auth/api/v1/teams/${this.userId}/reset-pin`
      const payload = {
        pin: this.pin,
        token,
      }

      await newAxiosIns.put(url, payload)
        .then(() => {
          this.$toast_success({ message: 'Informasi reset pin telah dikirim ke email kamu dan team' })
          this.sendMessage('reset_form')
        })
        .catch(() => {
          this.$toast_error({ message: 'Terjadi kesalahan saat mereset pin!' })
        })
    },
    sendMessage(param) {
      const message = {
        refetch: { type: 'REFETCH_GET_TEAM' },
        reset_form: { type: 'RESET_FORM' },
      }
      const iframe = document.querySelector('#team-container iframe')
      iframe.contentWindow.postMessage(message[param], '*')
    },
  },
}
</script>
